<template>
  <div
    style="font-family: 'Orbitron'; width: 98%; font-size: 20px"
    fluid
    class="bg-light-blue ma-2"
  >
    <slot name="title"></slot>
  </div>
  <v-table :hover="true" fixed-header height="100%" class="my-table ma-2">
    <template v-slot:default>
      <thead>
        <slot name="trheader"></slot>
      </thead>
      <tbody>
        <slot name="trows"></slot>
      </tbody>
    </template>
  </v-table>
</template>
